import React from "react";
import { Typography, Grid2 as Grid, Paper } from "@mui/material";
import { format, parseISO } from "date-fns";
import BarcodeIcon from "../../icons/Barcode";
import EditIcon from "@mui/icons-material/Edit";
import { useStyles } from "./History.styles";
import { EventHistoryListProps, EventHistoryListItemProps } from "./types";

const EventHistoryRow: React.FC<EventHistoryListItemProps> = ({
	sku,
	model,
	description,
	staffName,
	qty,
	action,
	date,
}) => {
	const classes = useStyles();

	return (
		<Grid size={12}>
			<Paper elevation={3} className={classes.EventHistoryRowContiner}>
				<Grid container spacing={1} alignItems="center">
					<Grid size={7}>
						<Typography variant="caption" noWrap>
							{sku}
						</Typography>
					</Grid>
					<Grid size={5}>
						<Typography variant="caption" noWrap>
							{model}
						</Typography>
					</Grid>
				</Grid>
				<Grid container alignItems="center">
					<Grid size={12}>
						<Typography variant="caption" noWrap>
							{description}
						</Typography>
					</Grid>
				</Grid>
				<Grid container alignItems="center">
					<Grid size={7}>
						<Typography variant="caption" noWrap>
							{staffName}
						</Typography>
					</Grid>
					<Grid size={3} className={classes.qty}>
						<Typography variant="body2" noWrap>
							Qty: {qty ?? 0}
						</Typography>
					</Grid>
					<Grid size={2}>
						{action === "scan" && <BarcodeIcon />}
						{action === "edit" && <EditIcon color="disabled" />}
					</Grid>
				</Grid>
				<Grid container alignItems="center">
					<Grid size={12}>
						<Typography variant="caption" noWrap>
							{format(parseISO(date), "EEE dd/MM/yy hh:mm:ss aaa")}
						</Typography>
					</Grid>
				</Grid>
			</Paper>
		</Grid>
	);
};

const EventHistoryList: React.FC<EventHistoryListProps> = ({ eventHistoryList }) => {
	const classes = useStyles();
	return (
		<Grid container justifyContent="center" spacing={1} className={classes.EventHistoryContainer}>
			{eventHistoryList.map((row, index) => (
				<EventHistoryRow
					key={index}
					sku={row.sku}
					model={row.model}
					description={row.description}
					staffName={row.staffName}
					qty={row.qty}
					action={row.action}
					date={row.date}
				/>
			))}
		</Grid>
	);
};

export default EventHistoryList;
